


















import { computed, defineComponent } from "@vue/composition-api";
import { AttachmentFile } from "@/types";
import BaseThumbnailButton from "@/components/BaseThumbnailButton";
import MediaPreview from "@/components/MediaPreview";

export default defineComponent({
  name: "AttachmentFilesPreview",
  components: {
    BaseThumbnailButton,
    MediaPreview,
  },
  props: {
    files: { type: Array as () => AttachmentFile[], default: [] },
    allowPublicFiles: { type: Boolean, default: false },
    allowedPublicFilesCount: { type: Number, default: 0 },
  },
  setup(props) {
    const isShowCover = computed<boolean>(() => {
      return props.allowPublicFiles && props.allowedPublicFilesCount > 0;
    });

    return {
      isShowCover,
    };
  },
});
